import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'components/Icon';

const ErrorIcon = ({isAccessDenied, size}) =>
  isAccessDenied ? (
    <Icon icon={Icon.OPTIONS.LOCK_CLOSED} size={size} />
  ) : (
    <Icon icon={Icon.OPTIONS.EXCLAMATION_TRIANGLE_OUTLINE} size={size} />
  );

ErrorIcon.SIZES = Icon.SIZES;

ErrorIcon.propTypes = {
  isAccessDenied: PropTypes.bool,
};

export default ErrorIcon;
